import FieldSet from '../../FieldSet';

import { OwnerImage } from './OwnerImage';
import { OwnerName } from './OwnerName';

export class OwnerFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [OwnerImage, OwnerName];
  }

  get title() {
    return 'Owner';
  }
}
